import React from "react";
import Button from "../Button";

export default function DashboardEmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="flex min-h-[300px] flex-col items-center justify-center rounded-[22px] border border-ink/10 bg-white px-6 py-12 text-center shadow-sm">
      <span className="flex h-14 w-14 items-center justify-center rounded-[18px] bg-[#FFF3D7] text-[#C47B00]">
        <Icon className="h-7 w-7" aria-hidden="true" />
      </span>
      <h2 className="mt-5 text-2xl font-extrabold text-ink">{title}</h2>
      <p className="mt-2 max-w-lg text-sm font-medium leading-relaxed text-ink/60">{description}</p>
      {action ? (
        <Button to={action.to} variant={action.variant || "yellow"} className="mt-6 min-h-11">
          {action.label}
          {action.icon ? <action.icon className="h-4 w-4" aria-hidden="true" /> : null}
        </Button>
      ) : null}
    </div>
  );
}
